import { API_URL, getRequest } from '@/assets/ts/helpers/api';
const getDashboardStats = () => getRequest(`${API_URL}/admin/dashboard/stats`, true);
export { getDashboardStats };
